import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { PlanningAlert } from "../../typings/PlanningAlert";
import { BackIcon } from "../icons/BackIcon";
import { handleRedirectToAlerts } from "../util/redirects";

type BackToAlertsProps = {
  planningAlert: PlanningAlert;
};

export const BackToAlerts = ({ planningAlert }: BackToAlertsProps) => {
  const { t } = useTranslation();
  return (
    <div className="mb-4 flex items-center">
      <BackIcon />
      <span
        onClick={() => handleRedirectToAlerts(planningAlert)}
        className="font-semibold text-platform-600 cursor-pointer"
      >
        {t("dashboard.planning_alerts.back_to_all_alerts")}
      </span>
    </div>
  );
};
